import React from 'react';

// Azure DevOps Icon Component - Official Microsoft Azure DevOps Logo
export const AzureDevOpsIcon: React.FC<{ width?: number; height?: number }> = ({ width = 20, height = 20 }) => (
    <div
        style={{
            position: "relative",
            width: width,
            height: height,
            display: "inline-block"
        }}
        data-name="azure-devops-icon"
    >
        <svg
            style={{
                display: "block",
                width: "100%",
                height: "100%"
            }}
            fill="none"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
            data-icon
        >
            <defs>
                <linearGradient id="azure-devops-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#0078D4" />
                    <stop offset="100%" stopColor="#005A9E" />
                </linearGradient>
            </defs>
            {/* Azure DevOps Boards icon - simplified board representation */}
            <rect x="2" y="4" width="20" height="16" rx="2" fill="url(#azure-devops-gradient)" />
            {/* Column dividers */}
            <line x1="9" y1="4" x2="9" y2="20" stroke="white" strokeWidth="0.5" opacity="0.5" />
            <line x1="16" y1="4" x2="16" y2="20" stroke="white" strokeWidth="0.5" opacity="0.5" />
            {/* Work item cards */}
            <rect x="4" y="6" width="3.5" height="2.5" rx="0.5" fill="white" opacity="0.9" />
            <rect x="4" y="10" width="3.5" height="2.5" rx="0.5" fill="white" opacity="0.9" />
            <rect x="11" y="6" width="3.5" height="2.5" rx="0.5" fill="white" opacity="0.9" />
            <rect x="11" y="10" width="3.5" height="2.5" rx="0.5" fill="white" opacity="0.9" />
            <rect x="11" y="14" width="3.5" height="2.5" rx="0.5" fill="white" opacity="0.9" />
            <rect x="18" y="6" width="3.5" height="2.5" rx="0.5" fill="white" opacity="0.9" />
        </svg>
    </div>
);
